export default class {
	constructor() {
			this.viewport = document.querySelector('meta[name="viewport"]');
			this.width_mobile = 360

			this.init();
	}
	init() {
			this.switchViewport();
			window.addEventListener('resize',() => {
				this.switchViewport();
			})
			//window.addEventListener('load', () => {
			//	this.switchViewportZoom();
			//})
	}
	switchViewport() {
			const value = window.outerWidth > 360 ? 'width=device-width,initial-scale=1' : 'width=360';
			if (this.viewport.getAttribute('content') !== value) {
					this.viewport.setAttribute('content', value);
			}
	}
	//switchViewportZoom() {
	//	//const value02 = (window.outerWidth >= 950 && window.outerWidth <= 1140) ? 'width=device-width,initial-scale=1' : 'width=1200';
	//	let zoom_value = window.outerWidth / window.innerWidth;
	//	let zoom_level = Math.floor(zoom_value * 10);
	//	console.log(zoom_level);
	//	console.log(screen.width+'.'+ window.outerWidth + '.' + window.innerWidth);
	//	if (zoom_level === 15) {
	//		if (window.innerWidth >= 940 && window.innerWidth <= 1140) {
	//			console.log('ok');
	//			this.viewport.setAttribute('content', 'width=1200');
	//		} else {
	//			console.log('ng');
	//		}
	//	}
	//}
}